module.exports = {
	"header": "styles__header___P9w1l"
};


/*****************
 ** WEBPACK FOOTER
 ** ./modules/components/Dragon/styles.css
 ** module id = 32
 ** module chunks = 0
 **/